(function () {
  var DEFAULT_MIN_LENGTH = 3;
  var INITIALS_MIN_LENGTH = 1;
  var BLOCKED_PATTERN = /<|>|&lt;|&gt;|javascript\s*:|data\s*:\s*text\/html|vbscript\s*:|on[a-z]+\s*=|script\s*:|<\/?\s*script/i;
  var FIELD_SELECTOR = [
    'input[name^="properties["][type="text"]',
    'textarea[name^="properties["]',
    'custom-product-field[data-type="text"] input[type="text"]',
    'custom-product-field[data-type="textarea"] textarea',
    '#nume-personalizat'
  ].join(',');
  var ERROR_CLASS = 'novvu-personalization-error';
  var INPUT_ERROR_CLASS = 'novvu-personalization-input-error';
  var HIDDEN_INPUT_CLASS = 'novvu-personalization-hidden-input';

  function getProductForm() {
    var productForm = document.querySelector('product-form[data-main="true"] form');
    return productForm || document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getFields() {
    return Array.prototype.slice.call(document.querySelectorAll(FIELD_SELECTOR)).filter(function (field) {
      return !field.disabled && field.offsetParent !== null;
    });
  }

  function getFieldLabel(field) {
    var nameMatch = String(field.name || '').match(/^properties\[(.+)\]$/);
    if (nameMatch) return nameMatch[1];

    var customField = field.closest('custom-product-field[data-name]');
    if (customField && customField.dataset.name) return customField.dataset.name;

    return field.id || '';
  }

  function getFieldMinLength(field) {
    var label = getFieldLabel(field).toLowerCase();
    return label.indexOf('initial') !== -1 ? INITIALS_MIN_LENGTH : DEFAULT_MIN_LENGTH;
  }

  function ensureFieldsBelongToForm() {
    var form = getProductForm();
    if (!form || !form.id) return;

    getFields().forEach(function (field) {
      if (!field.name) {
        if (field.id === 'nume-personalizat') {
          field.name = 'properties[Nume personalizat]';
        } else {
          var customField = field.closest('custom-product-field[data-name]');
          var propertyName = customField && customField.dataset.name ? customField.dataset.name.trim() : '';
          if (propertyName) {
            field.name = 'properties[' + propertyName + ']';
          }
        }
      }

      if (field.name && field.name.indexOf('properties[') === 0) {
        field.setAttribute('form', form.id);
        field.required = true;
        field.setAttribute('minlength', String(getFieldMinLength(field)));
        field.setAttribute('autocomplete', 'off');
      }
    });
  }

  function getErrorElement(field) {
    var wrapper = field.closest('.product-form__input') || field.parentElement;
    if (!wrapper) return null;

    var error = wrapper.querySelector('.' + ERROR_CLASS);
    if (!error) {
      error = document.createElement('p');
      error.className = ERROR_CLASS;
      error.setAttribute('role', 'alert');
      error.style.color = 'red';
      error.style.fontSize = '1.2rem';
      error.style.marginTop = '6px';
      error.style.display = 'none';
      wrapper.appendChild(error);
    }
    return error;
  }

  function showError(field, message) {
    var error = getErrorElement(field);
    field.classList.add(INPUT_ERROR_CLASS);
    field.style.borderColor = 'red';
    if (error) {
      error.textContent = message;
      error.style.display = 'block';
    }
  }

  function clearError(field) {
    var error = getErrorElement(field);
    field.classList.remove(INPUT_ERROR_CLASS);
    field.style.borderColor = 'rgba(var(--color-foreground), 0.15)';
    if (error) {
      error.textContent = '';
      error.style.display = 'none';
    }
  }

  function validateField(field) {
    //var value = String(field.value || '').trim();
    var value = String(field.value || '');
    var minLength = getFieldMinLength(field);
    //field.value = value;

    if (value.length < minLength) {
      return minLength === 1
        ? 'Te rugam sa introduci cel putin 1 caracter.'
        : 'Te rugam sa introduci minimum ' + minLength + ' caractere.';
    }

    if (BLOCKED_PATTERN.test(value)) {
      return 'Textul contine caractere sau cod nepermis.';
    }

    return '';
  }

  function validatePersonalizationFields() {
    ensureFieldsBelongToForm();

    var fields = getFields();
    var firstInvalid = null;

    fields.forEach(function (field) {
      var message = validateField(field);
      if (message) {
        showError(field, message);
        if (!firstInvalid) firstInvalid = field;
      } else {
        clearError(field);
      }
    });

    if (firstInvalid) {
      firstInvalid.focus();
      return false;
    }

    return true;
  }

  function getSelectedVariantId() {
    var form = getProductForm();
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function getPersonalizationProperties() {
    ensureFieldsBelongToForm();

    return getFields().reduce(function (properties, field) {
      var nameMatch = String(field.name || '').match(/^properties\[(.+)\]$/);
      var value = String(field.value || '').trim();

      if (nameMatch && value) {
        properties[nameMatch[1]] = value;
      }

      return properties;
    }, {});
  }

  function syncHiddenFormInputs() {
    var form = getProductForm();
    if (!form) return;

    Array.prototype.slice.call(form.querySelectorAll('.' + HIDDEN_INPUT_CLASS)).forEach(function (input) {
      input.parentNode.removeChild(input);
    });

    var properties = getPersonalizationProperties();
    Object.keys(properties).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.className = HIDDEN_INPUT_CLASS;
      input.name = 'properties[' + key + ']';
      input.value = properties[key];
      form.appendChild(input);
    });
  }

  function shouldHandleCartAdd(url, options) {
    if (url.indexOf('/cart/add') === -1 || getFields().length === 0) return false;

    var selectedVariantId = getSelectedVariantId();
    if (!selectedVariantId || !options || !options.body) return true;

    if (options.body instanceof FormData) {
      return String(options.body.get('id') || '') === selectedVariantId;
    }

    if (typeof options.body === 'string') {
      try {
        var jsonBody = JSON.parse(options.body);

        if (jsonBody.items && Array.isArray(jsonBody.items)) {
          return jsonBody.items.some(function (item) {
            return String(item.id || '') === selectedVariantId;
          });
        }

        return String(jsonBody.id || '') === selectedVariantId;
      } catch (error) {
        return true;
      }
    }

    return true;
  }

  function withPersonalizationProperties(options) {
    var properties = getPersonalizationProperties();
    if (Object.keys(properties).length === 0 || !options || !options.body) return options;

    if (options.body instanceof FormData) {
      Object.keys(properties).forEach(function (key) {
        options.body.set('properties[' + key + ']', properties[key]);
      });
      return options;
    }

    if (typeof options.body === 'string') {
      try {
        var jsonBody = JSON.parse(options.body);
        var selectedVariantId = getSelectedVariantId();

        if (jsonBody.items && Array.isArray(jsonBody.items)) {
          jsonBody.items = jsonBody.items.map(function (item) {
            if (String(item.id || '') !== selectedVariantId) return item;
            item.properties = Object.assign({}, item.properties || {}, properties);
            return item;
          });
        } else {
          jsonBody.properties = Object.assign({}, jsonBody.properties || {}, properties);
        }

        options.body = JSON.stringify(jsonBody);
      } catch (error) {}
    }

    return options;
  }

  function handleBlockingEvent(event) {
    if (validatePersonalizationFields()) {
      syncHiddenFormInputs();
      return true;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }

  function isMainProductSubmit(form) {
    var productForm = getProductForm();
    return !!form && !!productForm && form === productForm;
  }

  function isMainProductButton(button) {
    if (!button || button.closest('cart-drawer, .cart-drawer')) return false;

    var productFormElement = button.closest('product-form[data-main="true"]');
    if (productFormElement) return true;

    return button.classList.contains('main-product-atc') || button.id.indexOf('ProductSubmitButton-') === 0;
  }

  function bind() {
    ensureFieldsBelongToForm();

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!isMainProductSubmit(form)) return;
      handleBlockingEvent(event);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[name="add"], .main-product-atc, [data-skip-cart-button="true"]');
      if (!isMainProductButton(button)) return;
      handleBlockingEvent(event);
    }, true);

    document.addEventListener('input', function (event) {
      if (!event.target.matches(FIELD_SELECTOR)) return;
      if (validateField(event.target)) return;
      clearError(event.target);
      syncHiddenFormInputs();
    });

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function' && !window.__novvuPersonalizationFetchPatched) {
      window.__novvuPersonalizationFetchPatched = true;
      window.fetch = function () {
        var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
        var options = arguments[1] || {};

        if (shouldHandleCartAdd(url, options)) {
          if (!validatePersonalizationFields()) {
            return Promise.resolve(new Response(JSON.stringify({ error: 'invalid_personalization' }), {
              status: 422,
              headers: { 'Content-Type': 'application/json' }
            }));
          }

          arguments[1] = withPersonalizationProperties(options);
        }

        return originalFetch.apply(this, arguments);
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
